/**
 * Pull readable text out of a chat-completion envelope.
 * Keep in sync with backend/src/utils/unwrapResponseText.js.
 */

function messageContent(message) {
  if (message == null) return "";
  if (typeof message === "string") return message.trim();
  if (typeof message !== "object") return "";
  const content = message.content;
  if (typeof content === "string") return content.trim();
  if (Array.isArray(content)) {
    return content
      .map((part) => {
        if (typeof part === "string") return part;
        if (part && typeof part.text === "string") return part.text;
        if (part && typeof part.content === "string") return part.content;
        return "";
      })
      .join("")
      .trim();
  }
  return "";
}

function looksLikeJsonText(text) {
  return (
    (text.startsWith("{") && text.endsWith("}")) ||
    (text.startsWith("[") && text.endsWith("]"))
  );
}

export function unwrapResponseText(value) {
  if (value == null) return "";
  if (typeof value === "number" || typeof value === "boolean") return String(value);

  let parsed = value;
  let original = "";
  if (typeof value === "string") {
    original = value.trim();
    if (!original) return "";
    if (!looksLikeJsonText(original)) return original;
    try {
      parsed = JSON.parse(original);
    } catch {
      return original;
    }
  }

  if (typeof parsed !== "object" || parsed == null) {
    return original || String(parsed ?? "");
  }

  if (Array.isArray(parsed.choices) && parsed.choices[0]) {
    const fromChoice = messageContent(parsed.choices[0].message || parsed.choices[0]);
    if (fromChoice) return fromChoice;
  }

  if (parsed.message && typeof parsed.message === "object") {
    const fromMsg = messageContent(parsed.message);
    if (fromMsg) return fromMsg;
  }

  if (typeof parsed.role === "string") {
    const fromSelf = messageContent(parsed);
    if (fromSelf) return fromSelf;
  }

  return original;
}
